<script>
export default {
  computed: {
    // 线上线下
    stopType() {
      return this.$store.state.stopType;
    },
    // 所有厂家
    factoryList() {
      return this.$store.state.manufacturer;
    },
    // 订单状态翻译
    orderStateList() {
      const states = ['CREATED', 'OFFICER_APPROVED', 'STORE_COLLECTED', 'STORE_SENT', 'OFFICER_CLOSED', 'DONE_CLOSED', 'WAIT_PAY', 'EXPIRES']
      return states.map(state => ({ key: state, label: this.$t('order_state.' + state) }));
    },
    outTimes() {
      return [
        { key: 'order_review_timeout', label: 'reviewOutTime' }, // 超时未审核
        { key: 'store_order_deliver_collect_timeout', label: 'collectOutTime' }, // 物流超时未揽收
        { key: 'store_order_deliver_dispatch_receive_timeout', label: 'receiveOutTime' }, // 超时未签收
        { key: 'store_order_deliver_update_timeout', label: 'updateOutTime' }, // 物流数据超时未更新
        { key: 'store_order_send_timeout', label: 'sendOutTime' }, // 超时未发货
      ]
    },
    addressTypeList() {
      return [
        { key: 'INTERNAL', label: 'internal' }, // 超时未审核
        { key: 'FOREIGN', label: 'foreign' }, // 物流超时未揽收
      ]
    }
  },
  mounted() {
    this.getFactory();
  },
  methods: {
    getFactory() {
      if (this.$store.state.manufacturer.length === 0) {
        this.$store.dispatch('getFactoryList');
      }
    },
  }

}
</script>



// WEBPACK FOOTER //
// src/components/order/orderSelectFilter.vue